/**
 * Search Results — AJAX Filtering & Load More
 *
 * Server-side configuration (search query, post type, AJAX URL,
 * home URL) is read from data-* attributes on #search-results
 * so this file stays static and CSP-hashable.
 *
 * Scope all DOM to .filter-and-posts: the header also has a .searchform;
 * unscoped $('.searchform') would read the wrong (often empty) input.
 *
 * @package CMNBaseTheme
 */

/* global jQuery */

jQuery(document).ready(function ($) {
    'use strict';

    var $resultsContainer = $('#search-results');
    if (!$resultsContainer.length) {
        return;
    }

    var $searchSection = $resultsContainer.closest('.filter-and-posts');
    var $searchForm = $searchSection.find('form.searchform').first();
    var $searchInput = $searchForm.find('input[name="s"]');
    var $pageTitle = $searchSection.find('.page-title').first();

    var currentSearch =
        $resultsContainer.data('search-query') ||
        ($searchInput.length ? String($searchInput.val() || '') : '');
    var currentPostType = $resultsContainer.data('post-type') || '';
    var ajaxUrl = $resultsContainer.data('ajax-url');
    var homeUrl = $resultsContainer.data('home-url');
    var nonce = $resultsContainer.data('nonce');
    var i18n = {
        loadMore: $resultsContainer.data('i18nLoadMore') || 'Load More',
        error: $resultsContainer.data('i18nError') || 'Error loading results.',
        searchResultsPrefix:
            $resultsContainer.data('i18nSearchResultsPrefix') ||
            'Search Results for:',
        searchHeading:
            $resultsContainer.data('i18nSearchHeading') || 'Search',
    };
    var currentPage = 1;
    /** Incremented on each full replace so slower AJAX responses cannot override newer ones. */
    var replaceGeneration = 0;
    /** @type {jQuery.jqXHR|null} */
    var pendingReplaceXhr = null;

    // Keep in-memory query aligned with the visible field (filters / load more without submit).
    if ($searchInput.length) {
        $searchInput.on('input', function () {
            currentSearch = $(this).val();
        });
    }

    // Set active filter on load (both desktop buttons and mobile select)
    if (currentPostType) {
        $searchSection.find('.filter-btn').removeClass('active');
        $searchSection
            .find('.filter-btn[data-post-type="' + currentPostType + '"]')
            .addClass('active');
        $searchSection.find('#mobile-post-type-select').val(currentPostType);
    }

    // Handle search form submission (main search page form only)
    $searchForm.on('submit', function (e) {
        e.preventDefault();
        currentSearch = $searchInput.val();
        currentPage = 1;
        loadResults(currentSearch, currentPostType, currentPage, false);
    });

    // Handle desktop post type filter button clicks
    $searchSection.find('.filter-btn').on('click', function () {
        $searchSection.find('.filter-btn').removeClass('active');
        $(this).addClass('active');
        currentPostType = $(this).data('post-type');

        $searchSection.find('#mobile-post-type-select').val(currentPostType);

        currentPage = 1;
        loadResults(currentSearch, currentPostType, currentPage, false);
    });

    // Handle mobile post type select change
    $searchSection.find('#mobile-post-type-select').on('change', function () {
        currentPostType = $(this).val();

        $searchSection.find('.filter-btn').removeClass('active');
        $searchSection
            .find('.filter-btn[data-post-type="' + currentPostType + '"]')
            .addClass('active');

        currentPage = 1;
        loadResults(currentSearch, currentPostType, currentPage, false);
    });

    $searchSection.find('#search-reset-keyword-filters').on('click', function () {
        currentSearch = '';
        currentPostType = '';
        currentPage = 1;
        $searchInput.val('');
        $searchSection.find('.filter-btn').removeClass('active');
        $searchSection.find('.filter-btn[data-post-type=""]').addClass('active');
        $searchSection.find('#mobile-post-type-select').val('');
        loadResults('', '', currentPage, false);
    });

    // Handle load more button
    $(document).on('click', '#load-more-btn', function () {
        var $btn = $(this);
        currentPage = parseInt($btn.data('page'), 10) + 1;
        var maxPages = parseInt($btn.data('max-pages'), 10);

        if (currentPage <= maxPages) {
            $btn.empty()
                .append(document.createTextNode(i18n.loadMore + ' '))
                .append($('<span>', { class: 'search-loader' }));
            $btn.prop('disabled', true);
            loadResults(currentSearch, currentPostType, currentPage, true);
        }
    });

    function loadResults(searchTerm, postType, page, append) {
        if (!append && $searchInput.length) {
            var live = $searchInput.val();
            if (live !== undefined && live !== null) {
                searchTerm = live;
                currentSearch = live;
            }
        }

        var generationAtStart = null;
        if (!append) {
            if (pendingReplaceXhr) {
                pendingReplaceXhr.abort();
                pendingReplaceXhr = null;
            }
            replaceGeneration += 1;
            generationAtStart = replaceGeneration;
            $resultsContainer.html(
                '<div style="text-align: center; padding: 40px;">' +
                    '<span class="search-loader"></span></div>'
            );
            $searchSection.find('.load-more').remove();
        }

        var jqXHR = $.ajax({
            url: ajaxUrl,
            type: 'GET',
            data: {
                action: 'custom_search_filter',
                nonce: nonce,
                // Strip angle brackets only from the value actually sent to the server.
                s: searchTerm.replace(/[<>]/g, ''),
                post_type: postType,
                paged: page,
            },
            success: function (response) {
                if (
                    !append &&
                    generationAtStart !== null &&
                    generationAtStart !== replaceGeneration
                ) {
                    return;
                }
                if (response.success) {
                    if (append) {
                        $resultsContainer
                            .find('.search-results-list')
                            .append(response.data.html);
                    } else {
                        $resultsContainer.html(response.data.html);
                    }

                    $searchSection.find('.load-more').remove();
                    if (response.data.has_more) {
                        var $loadWrap = $('<div class="load-more"/>');
                        $('<button type="button" id="load-more-btn"/>')
                            .attr('data-page', page)
                            .attr('data-max-pages', response.data.max_pages)
                            .text(i18n.loadMore)
                            .appendTo($loadWrap);
                        $resultsContainer.after($loadWrap);
                    }

                    if (!append) {
                        // Never write back into the keyword field from JS.

                        // Mobile browsers can sync the visible input to the URL after pushState.
                        // If the user typed ahead of this response, updating ?s= with the OLD term
                        // shortens what they see — only sync URL/title when input still matches this
                        // response, or use the live value when it still equals what we requested.
                        var liveNow = $searchInput.length
                            ? String($searchInput.val() || '')
                            : searchTerm;
                        if (liveNow !== searchTerm) {
                            return;
                        }

                        var qp = [];
                        qp.push(
                            liveNow
                                ? 's=' + encodeURIComponent(liveNow)
                                : 's='
                        );
                        if (postType) {
                            qp.push(
                                'post_type=' + encodeURIComponent(postType)
                            );
                        }
                        window.history.pushState(
                            {},
                            '',
                            homeUrl + '?' + qp.join('&')
                        );

                        if (liveNow) {
                            $pageTitle
                                .empty()
                                .append(
                                    document.createTextNode(
                                        i18n.searchResultsPrefix + ' '
                                    )
                                )
                                .append($('<span>').text(liveNow));
                        } else {
                            $pageTitle.empty().text(i18n.searchHeading);
                        }
                    }
                } else {
                    if (!append) {
                        $resultsContainer.empty().append(
                            $('<div class="no-results"/>').append(
                                $('<p/>').text(i18n.error)
                            )
                        );
                    } else {
                        $('#load-more-btn')
                            .text(i18n.loadMore)
                            .prop('disabled', false);
                    }
                }
            },
            complete: function () {
                if (!append && jqXHR === pendingReplaceXhr) {
                    pendingReplaceXhr = null;
                }
            },
            error: function (xhr, status) {
                if (status === 'abort') {
                    return;
                }
                if (
                    !append &&
                    generationAtStart !== null &&
                    generationAtStart !== replaceGeneration
                ) {
                    return;
                }
                if (!append) {
                    $resultsContainer.empty().append(
                        $('<div class="no-results"/>').append(
                            $('<p/>').text(i18n.error)
                        )
                    );
                } else {
                    $('#load-more-btn')
                        .text(i18n.loadMore)
                        .prop('disabled', false);
                }
            },
        });

        if (!append) {
            pendingReplaceXhr = jqXHR;
        }
    }
});
